import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faUser, faClock, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

export default {
  init() { // JavaScript to be fired on all pages
    library.add(
      faFacebookF, faTwitter, faLinkedinIn, faUser, faClock, faEnvelope
    );
    dom.watch();

    /**
     * Bulma's Hamburger Expander
     */
    $('.navbar-burger').click(function () {
      $('.navbar-burger').toggleClass('is-active');
      $('.navbar-menu').toggleClass('is-active');
    });
    document.querySelectorAll('.navbar-link').forEach(function (navbarLink) {
      navbarLink.addEventListener('click', function () {
        navbarLink.nextElementSibling.classList.toggle('is-hidden-mobile');
      })
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js